<template>
  <div>
    <div class="menu-web">
      <!-- top -->
      <div class="top">
        <div class="left">
          <ul>
            <li>
              <span to="/">Inicio</span>
            </li>
            <li>
              <span to="/nosotros">Nosotros</span>
            </li>
            <li>
              <span to="/sucursales">Sucursales</span>
            </li>
            <li>
              <span to="/contacto">Contacto</span>
            </li>
          </ul>
        </div>
        <div class="logo">
          <img src="@/assets/img/logo.png" alt="">
        </div>
        <div class="right">
          <div class="icons">
            <i class="fab fa-facebook-f" style="font-size:22px;"></i>
            <i class="fab fa-instagram" style="font-size:32px;"></i>
          </div>
          <div class="cta">
            <v-btn outlined color="#000" class="font-weight-black">¿Cómo comprar?</v-btn>
          </div>
        </div>
      </div>
      <!-- /top -->

      <!-- categorias -->
      <div class="categorias">
        <ul>
          <li>
            <span to="/categorias/1">Recamaras</span>
          </li>
          <li>
            <span to="/categorias/1">Comedores</span>
          </li>
          <li>
            <span to="/categorias/1">Salas</span>
          </li>
          <li>
            <span to="/categorias/1">Otros muebles</span>
          </li>
         
        </ul>
      </div>
      <!-- /categorias -->

    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",

  data: () => {
    return {
      scrollPosition: null
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  }
};
</script>

<style lang="scss">
  .menu-web{
    width: 100%;
    position: relative;

    

    .top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 125px;

      .left{
        ul{
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;

          li{
            span{
              padding: 0 15px;
              color:#000;
              font-weight: 900;
            }
            span.active{
              background: inherit;
              color: #c39767;
            }
          }
        }
      }

      .right{
        display: flex;
        align-items: center;

        .cta{
          margin-left: 15px;
          margin-right: 20px;
        }
        .icons{
          font-size: 32px;
          display: flex;
          align-items: center;

          i{
            padding-right: 15px;
          }
        }
      }

      .logo{
        width: 75px;
        position: absolute;
        right: 0;
        left: 0;
        top: 23px;
        margin:auto;
        img{
          width: 100%;
        }
      }
    }

    .categorias{
      width: 100%;
      background: #c39767;
      display: flex;
      justify-content: center;

      ul{
        list-style: none;
        margin:0;
        padding:0;
        display: flex;
        align-items: center;

        li{
          padding:15px 0;
          span{
            padding:0 20px;
            color: #fff;
            font-weight: 900;
            text-transform: uppercase;
            font-size:14px;
          }
        }
      }
    }
  }
</style>

